export const MOVE = 'move';
export const RESIZE = 'resize';

// custom event
export const EVENTS = '/mobile/events';

// timeoff
export const TIMEOFFS = '/mobile/timeoffs';
